import React from 'react';
import PropTypes from 'prop-types';

import ObjectRepeat from './ObjectRepeat';

/**
 * Banner.
 * Re-usable component for product packages.
 *
 * @author  Manny
 * @param   {Boolean}   props.buyNow          Check if method is buyNow.
 * @param   {String}    props.industryKey     Name of the industry.
 * @param   {Object}    props.industryPackage List of packages for the industry.
 * @param   {Function}  props.onSelectPackage Handles onClick for selecting a package.
 * @param   {String}    props.product         Name of the product.
 * @returns {JSX.Element} The component markup.
 */

const Banner = ({ buyNow, industryKey, industryPackage, onSelectPackage, product }) => {
  return (
    <div className='feature-wrapper'>
      <div id='rp-features-table' className='row rpp-features'>
        <div className='col-sm-12'>
          <div className={`row${product == 'commercial' && ' display-flex'}`}>
            <ObjectRepeat
              buyNow={buyNow}
              industryKey={industryKey}
              onSelectPackage={onSelectPackage}
              packages={industryPackage !== undefined ? industryPackage.packages : null}
              product={product}
            />
          </div>
          <div className='row margin-top-20 padding-top-10'>
          </div>
        </div>
      </div>
    </div>
  );
};

Banner.propTypes = {
  buyNow: PropTypes.bool,
  industryKey: PropTypes.string,
  industryPackage: PropTypes.object,
  onSelectPackage: PropTypes.func.isRequired,
  product: PropTypes.string.isRequired
};

export default Banner;
